export const generateUsernameSuggestion = (username: string) => {
// Replace spaces with underlines
  let suggestion = username.replace(/\s+/g, '_');
// Remove accents and special chars
  suggestion = suggestion.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return suggestion.toLowerCase();
};